const ORDER_EXTRA_STEPPER_STEPS = {
  "New Data Received": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Assigned Request",
      "Data Received Incomplete",
      "Data Preparation and Completeness",
    ],
    workFlowIcons: ["TickIcon", "InProgressIcon", "InactiveIcon"],
    stepper: 1,
  },
  "Data Preparation and Completeness": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Data Received",
      "Data Preparation and Completeness",
      "Preparing Analyzer & Memo",
    ],
    workFlowIcons: ["TickIcon", "TickIcon", "InactiveIcon"],
    stepper: 2,
  },
  "Preparation & completeness in- progress": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Completeness L1 Review",
      "Completeness L2 Review",
      "Completeness Ready for Delivery",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 2,
  },
  "Data Preparation and Completeness In Progress": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Completeness L1 Review",
      "Completeness L2 Review",
      "Completeness Ready for Delivery",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 2,
  },

  "Completeness Review": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Completeness L1 Review",
      "Completeness L2 Review",
      "Completeness Ready for Delivery",
    ],
    workFlowIcons: ["TickIcon", "TickIcon", "InProgressIcon"],
    stepper: 2,
  },
  "Awaiting Engagement Team Completeness Confirmation": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Completeness L2 Review",
      "Completeness Ready for Delivery",
      "Awaiting Engagement Team Completeness Confirmation",
    ],
    workFlowIcons: ["TickIcon", "TickIcon", "InProgressIcon"],
    stepper: 2,
  },
  "Preparing Analyzer & Memo": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Analyzer & memo - L1 Review",
      "Analyzer & memo  L2 Review",
      "Analyser & Memo - Ready for Delivery",
    ],
    workFlowIcons: ["InactiveIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 3,
  },
};
const ORDER_EXTRA_BUT_REQUIRED_STEPPER_STEPS = {
  "Data Received": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Data Received",
      "Data Received Incomplete",
      "Preparation & completeness in-progress",
    ],
    workFlowIcons: ["TickIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 1,
  },
  "Data Validation": {
    workflowHeader: "Current Axon Status",
    workflowSteps: ["File Validation", "File Mapping", "Data Validation"],
    workFlowIcons: ["TickIcon", "TickIcon", "TickIcon"],
    stepper: 1,
  },
  "Completeness L1 Review": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Completeness L1 Review",
      "Completeness L2 Review",
      "Awaiting Completeness confirmation",
    ],
    //  workFlowIcons: ["TickIcon", "InactiveIcon", "InactiveIcon"],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 2,
  },
  "Analyser & memo L1 review": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Analyser & memo - L1 Review",
      "Analyser & memo L2 Review",
      "Analyser & Memo - Ready for Delivery",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 3,
  },
  "Analyser & memo L2 Review": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Analyser & memo L2 Review",
      "Analyser & Memo - Ready for Delivery",
      "Delivered Analyser",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 3,
  },
  "Delivered for Onshore Review": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Preparing Analyzer & Memo",
      "Delivered for Onshore Review",
      "Project Complete",
    ],
    workFlowIcons: ["TickIcon", "TickIcon", "InactiveIcon"],
    stepper: 4,
  },
  "Project Complete": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Preparing Analyser & Memo",
      "Delivered Analyser",
      "Project Complete",
    ],
    workFlowIcons: ["TickIcon", "TickIcon", "TickIcon"],
    stepper: 5,
  },
};
export const WORKFLOW_STATUS_CONFIG_DATA = {
  "Order Validation": {
    workflowHeader: "Current Axon Status",
    workflowSteps: ["Assigned Request", "Data Received"],
    workFlowIcons: ["InactiveIcon", "InactiveIcon"],
    stepper: 0,
  },
  "Assigned Request": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Assigned Request",
      "Data Received",
      "Data Received Incomplete",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 0,
  },

  "Data Received Incomplete": {
    workflowHeader: "Current Axon Status",
    workflowSteps: ["Data Received Incomplete", "Data Received"],
    workFlowIcons: ["InProgressIcon", "InactiveIcon"],
    stepper: 1,
  },

  "Preparation & completeness in-progress": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Preparation & completeness in-progress",
      "Completeness L1 Review",
      "Completeness L2 Review",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 2,
  },

  "Completeness - L1 review": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Completeness L1 Review",
      "Completeness L2 Review",
      "Awaiting Completeness confirmation",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 2,
  },

  "Completeness L2 Review": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Completeness L2 Review",
      "Awaiting Completeness confirmation",
      "Analyser & Memo in Progress",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 2,
  },
  "Awaiting Completeness confirmation": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Awaiting Completeness confirmation",
      "Analyser & Memo in Progress",
      "Analyzer & Memo - L1 Review",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 2,
  },
  "Completeness Ready for Delivery": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Completeness Ready for Delivery",
      "Awaiting Completeness confirmation",
      "Analyser & Memo in Progress",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 2,
  },

  "Analyser & Memo in Progress": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Analyser & Memo in Progress",
      "Analyzer & Memo - L1 Review",
      "Analyzer & Memo - L2 Review",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 3,
  },

  "Analyzer & Memo - L1 Review": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Analyser & Memo - L1 Review",
      "Analyser & Memo - L2 Review",
      "Analyser & Memo - Ready for Delivery",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 3,
  },

  "Analyzer & Memo - L2 Review": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Analyser & Memo - L2 Review",
      "Analyser & Memo - Ready for Delivery",
      "Delivered Analyser",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 3,
  },

  "Analyser & Memo - Ready for Delivery": {
    workflowHeader: "Current Axon Status",
    workflowSteps: [
      "Analyser & Memo - Ready for Delivery",
      "Delivered Analyser",
      "Project Complete",
    ],
    workFlowIcons: ["InProgressIcon", "InactiveIcon", "InactiveIcon"],
    stepper: 3,
  },

  "Delivered completeness": {
    workflowHeader: "Current Axon Status",
    workflowSteps: ["Delivered completeness", "Project Complete"],
    workFlowIcons: ["InProgressIcon", "InactiveIcon"],
    stepper: 2,
  },

  "Delivered Analyser": {
    workflowHeader: "Current Axon Status",
    workflowSteps: ["Delivered Analyser", "Project Complete"],
    workFlowIcons: ["InProgressIcon", "InactiveIcon"],
    stepper: 4,
  },

  ...ORDER_EXTRA_BUT_REQUIRED_STEPPER_STEPS,
  ...ORDER_EXTRA_STEPPER_STEPS,
};
